<template>
  <div class="col-md-4">
    <div class="ibox">
      <div class="ibox-content ibox-content-padding-xs">
        <h2 class="truncate">Public Job Settings</h2>

        <div class="form-group">
          <label class="control-label">Minimum Quantity Cutoff</label>
          <div class="input-group">
            <input type="number" class="form-control" v-model="publicJobCutoff" />
            <span class="input-group-addon">/tonne</span>
          </div><!-- /.input-group -->
        </div><!-- /.form-group -->
      </div>
      <div class="ibox-footer">
        <ladda-button :on-click="handleSaveSetting" class="btn btn-xs btn-success">Save</ladda-button>
      </div>
    </div><!-- /.ibox -->
  </div>
</template>

<script>
import { LaddaButton } from 'components/forms'
import { stateMapper } from 'mixins/settings'
import { mapState, mapActions } from 'vuex'
import { pick } from 'lodash'

export default {
  mixins: [stateMapper],

  components: {
    LaddaButton
  },

  created () {
    // Get the system settings
    this.getSettings()
  },

  computed: {
    ...mapState('settings', ['settings'])
  },

  methods: {
    ...mapActions('settings', ['updateSettings', 'getSettings']),

    /**
     * Save the public job cutoff amount
     */
    handleSaveSetting () {
      return this.updateSettings(pick(this.settings, [
        'public_job_cutoff'
      ]))
    }
  }
}
</script>



// WEBPACK FOOTER //
// PublicJob.vue?0ad33ff6